/** This is a Container.  Place all code
 * portions that deal with the server
 * or Redux in this file.  It is not
 * for handling display templates */

import {connect} from 'react-redux'
import * as actions from './NetWorthDonutChartActions'
import NetWorthDonutChartView from './NetWorthDonutChartView'
import {get_chart_data, chartTotalOrDefaultSelector } from './NetWorthDonutChartSelector'

const mapStateToProps = (state, ownProps) => {
    let subdivision = state.NetWorthDonutChart[ownProps.clientId]

    let breakdown;
    const chart_type = ownProps.type || (subdivision ? subdivision.chart_type : null);
    if (subdivision && chart_type) {
        const l = subdivision[chart_type].resp_data.BalanceSheet.length;
        if (l < 1) {
            throw "Expected BalanceSheet to be a non empty array";
        }
        breakdown = subdivision[chart_type].resp_data.BalanceSheet[l - 1];
    }

    return {
        chart_data: get_chart_data(state, ownProps),
        breakdown: breakdown,
        is_initialized: subdivision ? subdivision.is_initialized : null,
        chart_type: chart_type,
        Assets: subdivision ? subdivision.Assets : null,
        Liabilities: subdivision ? subdivision.Liabilities : null,
        range: ownProps.range || (subdivision ? subdivision.range : null),
        chartTotal: chartTotalOrDefaultSelector(state, ownProps),
    }
}

const mapDispatchToProps = (dispatch) => ({
    fetch_data(type, clientId) {
        dispatch(actions.fetch_data(type, clientId))
    },
    set_type(type, clientId) {
        dispatch(actions.set_type(type, clientId))
    }
})

const NetWorthDonutChart = connect(
    mapStateToProps,
    mapDispatchToProps
)(NetWorthDonutChartView)

export default NetWorthDonutChart